(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 33539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42708);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62642);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);





 // import CTAV3 from "../components/CTA-v3";
// import TestimonialV1 from "../components/Testimonial-v1";
// import WhoIs from "../components/home/WhoIs";
// import Newsletter from "../components/home/Newsletter";
// import Investors from "../components/home/Investors";
// import EasyTrade from "../components/EasyTrade";
// import USP from "../components/USP";
// import Products from "../components/home/Products";
// import Invest from "../components/home/Invest";
// import Services from "../components/Services";
// import Banner from "../components/home/Banner";
//




var Banner = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(7006), __webpack_require__.e(1118), __webpack_require__.e(5782)]).then(__webpack_require__.bind(__webpack_require__, 47492));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(47492)];
    }
  }
});
var Services = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return __webpack_require__.e(/* import() */ 6984).then(__webpack_require__.bind(__webpack_require__, 46984));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(46984)];
    }
  }
});
var Invest = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(7724), __webpack_require__.e(6727)]).then(__webpack_require__.bind(__webpack_require__, 49982));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(49982)];
    }
  }
});
var Products = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return __webpack_require__.e(/* import() */ 9339).then(__webpack_require__.bind(__webpack_require__, 29339));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(29339)];
    }
  }
});
var USP = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return __webpack_require__.e(/* import() */ 2127).then(__webpack_require__.bind(__webpack_require__, 62127));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(62127)];
    }
  }
});
var Newsletter = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(7006), __webpack_require__.e(7820)]).then(__webpack_require__.bind(__webpack_require__, 87820));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(87820)];
    }
  }
});
var WhoIs = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(7724), __webpack_require__.e(1166)]).then(__webpack_require__.bind(__webpack_require__, 35196));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(35196)];
    }
  }
});
var TestimonialV1 = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(2013), __webpack_require__.e(7724), __webpack_require__.e(1118), __webpack_require__.e(1239), __webpack_require__.e(8660)]).then(__webpack_require__.bind(__webpack_require__, 69177));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(69177)];
    }
  }
});
var CTAV3 = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(7724), __webpack_require__.e(7006), __webpack_require__.e(3927)]).then(__webpack_require__.bind(__webpack_require__, 69589));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(69589)];
    }
  }
});
var EasyTrade = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(7724), __webpack_require__.e(4289), __webpack_require__.e(1917)]).then(__webpack_require__.bind(__webpack_require__, 64289));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(64289)];
    }
  }
});
var Investors = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(7724), __webpack_require__.e(1946)]).then(__webpack_require__.bind(__webpack_require__, 2073));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(2073)];
    }
  }
});

var Home = function Home(_ref) {
  var _getPost$data, _getPost$data2, _getPost$data2$sectio, _getPost$data3, _getPost$data3$sectio, _getPost$data4, _getPost$data4$sectio, _getPost$data5, _getPost$data5$sectio, _getPost$data6, _getPost$data6$sectio, _getPost$data7, _getPost$data7$sectio, _getPost$data8, _getPost$data8$sectio, _getPost$data9, _getPost$data9$sectio, _getPost$data10, _getPost$data10$secti, _getPost$data11, _getPost$data11$secti, _getPost$data12, _getPost$data12$secti, _getPost$data13, _getPost$data13$secti, _getPost$data14, _getPost$data14$secti, _getPost$data15, _getPost$data15$secti, _getPost$data16, _getPost$data16$page_, _getPost$data17, _getPost$data17$page_;

  var data = _ref.data,
      winWidth = _ref.winWidth;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)('90'),
      offset = _useState[0],
      setOffset = _useState[1];

  var getPost = data && data;

  var _useInView = (0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_5__/* .useInView */ .YD)(),
      ref = _useInView.ref,
      inView = _useInView.inView;

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0),
      windowWidth = _useState2[0],
      setWindowWidth = _useState2[1];

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
  var currentUrl = router && router.asPath;
  var page_data = getPost === null || getPost === void 0 ? void 0 : (_getPost$data = getPost.data) === null || _getPost$data === void 0 ? void 0 : _getPost$data.page_data;
  var home_banner = getPost === null || getPost === void 0 ? void 0 : (_getPost$data2 = getPost.data) === null || _getPost$data2 === void 0 ? void 0 : (_getPost$data2$sectio = _getPost$data2.sections) === null || _getPost$data2$sectio === void 0 ? void 0 : _getPost$data2$sectio.find(function (f) {
    var _f$section_data;

    return (f === null || f === void 0 ? void 0 : (_f$section_data = f.section_data) === null || _f$section_data === void 0 ? void 0 : _f$section_data.slug) === 'banner';
  });
  var feature_box = getPost === null || getPost === void 0 ? void 0 : (_getPost$data3 = getPost.data) === null || _getPost$data3 === void 0 ? void 0 : (_getPost$data3$sectio = _getPost$data3.sections) === null || _getPost$data3$sectio === void 0 ? void 0 : _getPost$data3$sectio.find(function (f) {
    var _f$section_data2;

    return (f === null || f === void 0 ? void 0 : (_f$section_data2 = f.section_data) === null || _f$section_data2 === void 0 ? void 0 : _f$section_data2.slug) === 'feature-box';
  });
  var services = getPost === null || getPost === void 0 ? void 0 : (_getPost$data4 = getPost.data) === null || _getPost$data4 === void 0 ? void 0 : (_getPost$data4$sectio = _getPost$data4.sections) === null || _getPost$data4$sectio === void 0 ? void 0 : _getPost$data4$sectio.find(function (f) {
    var _f$section_data3;

    return (f === null || f === void 0 ? void 0 : (_f$section_data3 = f.section_data) === null || _f$section_data3 === void 0 ? void 0 : _f$section_data3.slug) === 'serivecs';
  });
  var investing = getPost === null || getPost === void 0 ? void 0 : (_getPost$data5 = getPost.data) === null || _getPost$data5 === void 0 ? void 0 : (_getPost$data5$sectio = _getPost$data5.sections) === null || _getPost$data5$sectio === void 0 ? void 0 : _getPost$data5$sectio.find(function (f) {
    var _f$section_data4;

    return (f === null || f === void 0 ? void 0 : (_f$section_data4 = f.section_data) === null || _f$section_data4 === void 0 ? void 0 : _f$section_data4.slug) === 'investing';
  });
  var products = getPost === null || getPost === void 0 ? void 0 : (_getPost$data6 = getPost.data) === null || _getPost$data6 === void 0 ? void 0 : (_getPost$data6$sectio = _getPost$data6.sections) === null || _getPost$data6$sectio === void 0 ? void 0 : _getPost$data6$sectio.find(function (f) {
    var _f$section_data5;

    return (f === null || f === void 0 ? void 0 : (_f$section_data5 = f.section_data) === null || _f$section_data5 === void 0 ? void 0 : _f$section_data5.slug) === 'products-home';
  });
  var expert = getPost === null || getPost === void 0 ? void 0 : (_getPost$data7 = getPost.data) === null || _getPost$data7 === void 0 ? void 0 : (_getPost$data7$sectio = _getPost$data7.sections) === null || _getPost$data7$sectio === void 0 ? void 0 : _getPost$data7$sectio.find(function (f) {
    var _f$section_data6;

    return (f === null || f === void 0 ? void 0 : (_f$section_data6 = f.section_data) === null || _f$section_data6 === void 0 ? void 0 : _f$section_data6.slug) === 'expert';
  });
  var easytrade = getPost === null || getPost === void 0 ? void 0 : (_getPost$data8 = getPost.data) === null || _getPost$data8 === void 0 ? void 0 : (_getPost$data8$sectio = _getPost$data8.sections) === null || _getPost$data8$sectio === void 0 ? void 0 : _getPost$data8$sectio.find(function (f) {
    var _f$section_data7;

    return (f === null || f === void 0 ? void 0 : (_f$section_data7 = f.section_data) === null || _f$section_data7 === void 0 ? void 0 : _f$section_data7.slug) === 'easy-trade';
  });
  var easyx = getPost === null || getPost === void 0 ? void 0 : (_getPost$data9 = getPost.data) === null || _getPost$data9 === void 0 ? void 0 : (_getPost$data9$sectio = _getPost$data9.sections) === null || _getPost$data9$sectio === void 0 ? void 0 : _getPost$data9$sectio.find(function (f) {
    var _f$section_data8;

    return (f === null || f === void 0 ? void 0 : (_f$section_data8 = f.section_data) === null || _f$section_data8 === void 0 ? void 0 : _f$section_data8.slug) === 'easy-x';
  });
  var investor = getPost === null || getPost === void 0 ? void 0 : (_getPost$data10 = getPost.data) === null || _getPost$data10 === void 0 ? void 0 : (_getPost$data10$secti = _getPost$data10.sections) === null || _getPost$data10$secti === void 0 ? void 0 : _getPost$data10$secti.find(function (f) {
    var _f$section_data9;

    return (f === null || f === void 0 ? void 0 : (_f$section_data9 = f.section_data) === null || _f$section_data9 === void 0 ? void 0 : _f$section_data9.slug) === 'investment-calculator';
  });
  var newsletter = getPost === null || getPost === void 0 ? void 0 : (_getPost$data11 = getPost.data) === null || _getPost$data11 === void 0 ? void 0 : (_getPost$data11$secti = _getPost$data11.sections) === null || _getPost$data11$secti === void 0 ? void 0 : _getPost$data11$secti.find(function (f) {
    var _f$section_data10;

    return (f === null || f === void 0 ? void 0 : (_f$section_data10 = f.section_data) === null || _f$section_data10 === void 0 ? void 0 : _f$section_data10.slug) === 'news-letter';
  });
  var who = getPost === null || getPost === void 0 ? void 0 : (_getPost$data12 = getPost.data) === null || _getPost$data12 === void 0 ? void 0 : (_getPost$data12$secti = _getPost$data12.sections) === null || _getPost$data12$secti === void 0 ? void 0 : _getPost$data12$secti.find(function (f) {
    var _f$section_data11;

    return (f === null || f === void 0 ? void 0 : (_f$section_data11 = f.section_data) === null || _f$section_data11 === void 0 ? void 0 : _f$section_data11.slug) === 'unbelievable';
  });
  var testimonial = getPost === null || getPost === void 0 ? void 0 : (_getPost$data13 = getPost.data) === null || _getPost$data13 === void 0 ? void 0 : (_getPost$data13$secti = _getPost$data13.sections) === null || _getPost$data13$secti === void 0 ? void 0 : _getPost$data13$secti.find(function (f) {
    var _f$section_data12;

    return (f === null || f === void 0 ? void 0 : (_f$section_data12 = f.section_data) === null || _f$section_data12 === void 0 ? void 0 : _f$section_data12.slug) === 'testimonial';
  });
  var cta = getPost === null || getPost === void 0 ? void 0 : (_getPost$data14 = getPost.data) === null || _getPost$data14 === void 0 ? void 0 : (_getPost$data14$secti = _getPost$data14.sections) === null || _getPost$data14$secti === void 0 ? void 0 : _getPost$data14$secti.find(function (f) {
    var _f$section_data13;

    return (f === null || f === void 0 ? void 0 : (_f$section_data13 = f.section_data) === null || _f$section_data13 === void 0 ? void 0 : _f$section_data13.slug) === 'cta';
  });
  var modaldata = getPost === null || getPost === void 0 ? void 0 : (_getPost$data15 = getPost.data) === null || _getPost$data15 === void 0 ? void 0 : (_getPost$data15$secti = _getPost$data15.sections) === null || _getPost$data15$secti === void 0 ? void 0 : _getPost$data15$secti.find(function (f) {
    var _f$section_data14;

    return (f === null || f === void 0 ? void 0 : (_f$section_data14 = f.section_data) === null || _f$section_data14 === void 0 ? void 0 : _f$section_data14.slug) === 'opening-popup';
  }); // useEffect(() => {
  //     if (typeof window !== 'undefined') {
  //         // Place your hook-based code here
  //         const box = document.querySelectorAll('.box');
  //         const boxplus = document.querySelectorAll('.boxr');
  //         const cta = document.querySelectorAll('.cta');
  //         let reveal = gsap.utils.toArray(".reveal");
  //         reveal.forEach((cont) => {
  //             let img = cont.querySelector("img");
  //             let tl = gsap.timeline({
  //                 scrollTrigger: {
  //                     trigger: cont,
  //                     toggleActions: "restart none none reset",
  //                 },
  //             });
  //             // parallax
  //             // if () {
  //             gsap.to(img, {
  //                 yPercent: 15,
  //                 ease: "none",
  //                 scrollTrigger: {
  //                     trigger: cont,
  //                     // markers: true,
  //                     scrub: true
  //                 }
  //             });
  //             // }
  //
  //             // image reveal
  //             tl.fromTo(
  //                 cont,
  //                 1.5,
  //                 {
  //                     xPercent: -100,
  //                     ease: "Expo.easeInOut",
  //                 },
  //                 {
  //                     xPercent: 0,
  //                     ease: "Expo.easeInOut",
  //                 }
  //             );
  //
  //             tl.fromTo(
  //                 img,
  //                 1.5,
  //                 {
  //                     xPercent: 100,
  //                     ease: "Expo.easeInOut",
  //                     scale: 1.1,
  //                 },
  //                 {
  //                     delay: -1.5,
  //                     xPercent: 0,
  //                     scale: 1,
  //                     ease: "Expo.easeInOut",
  //                 }
  //             );
  //         });
  //
  //
  //         box.forEach((el, index) => {
  //             gsap.fromTo(el, {
  //                 y: -150,
  //                 ease: "none",
  //             }, {
  //                 y: 0,
  //                 autoAlpha: 1,
  //                 ease: "power2",
  //                 duration: 1,
  //                 scrollTrigger: {
  //                     id: `${index + 1}`,
  //                     trigger: el,
  //                     scrub: true
  //                 }
  //             });
  //         });
  //
  //         boxplus.forEach((el, index) => {
  //             gsap.fromTo(el, {
  //                 y: 150,
  //                 ease: "none",
  //             }, {
  //                 y: 0,
  //                 autoAlpha: 1,
  //                 ease: "power2",
  //                 duration: 1,
  //                 scrollTrigger: {
  //                     id: `${index + 1}`,
  //                     trigger: el,
  //                     scrub: true
  //                 }
  //             });
  //         });
  //         cta.forEach((el, index) => {
  //             gsap.fromTo(el, {
  //                 y: -50,
  //                 ease: "none",
  //             }, {
  //                 y: 0,
  //                 autoAlpha: 1,
  //                 ease: "power2",
  //                 duration: 1,
  //                 scrollTrigger: {
  //                     id: `${index + 1}`,
  //                     trigger: el,
  //                     scrub: true
  //                 }
  //             });
  //         });
  //
  //     }
  // }, [Router, router.pathname]);
  // get offset for container

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (window.innerWidth > 767) {
      setOffset(document.querySelector('.container').offsetLeft + 15);
    }
  });
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var updateOffset = function updateOffset() {
      if (window.innerWidth > 767) {
        var container = document.querySelector('.container');

        if (container) {
          setOffset(container.offsetLeft + 15);
        }
      }
    }; // Add an event listener for the DOMContentLoaded event


    document.addEventListener('DOMContentLoaded', updateOffset); // Add event listener to update offset on window resize

    window.addEventListener('resize', updateOffset);
    window.addEventListener('load', updateOffset);
    return function () {
      document.removeEventListener('DOMContentLoaded', updateOffset);
      window.removeEventListener('resize', updateOffset);
      window.removeEventListener('load', updateOffset);
    };
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    // Function to handle window resize
    var handleResize = function handleResize() {
      setWindowWidth(window.innerWidth);
    }; // Initial window width


    setWindowWidth(window.innerWidth); // Add event listener for window resize

    window.addEventListener('resize', handleResize); // Cleanup the event listener on component unmount

    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  var location = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    // Use GSAP to animate opacity from 0 to 1
    gsap__WEBPACK_IMPORTED_MODULE_6__/* .gsap.to */ .p8.to('.hide', {
      alpha: 1,
      visibility: 'visible',
      display: 'block',
      duration: 0.5,
      delay: 1
    });
  }, [location.pathname]); // Run this effect only once when the component mounts

  console.log(getPost, 'ok');
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_0__/* .NextSeo */ .PB, {
      title: getPost === null || getPost === void 0 ? void 0 : (_getPost$data16 = getPost.data) === null || _getPost$data16 === void 0 ? void 0 : (_getPost$data16$page_ = _getPost$data16.page_data) === null || _getPost$data16$page_ === void 0 ? void 0 : _getPost$data16$page_.meta_title,
      description: getPost === null || getPost === void 0 ? void 0 : (_getPost$data17 = getPost.data) === null || _getPost$data17 === void 0 ? void 0 : (_getPost$data17$page_ = _getPost$data17.page_data) === null || _getPost$data17$page_ === void 0 ? void 0 : _getPost$data17$page_.meta_description,
      openGraph: {
        type: 'website',
        url: currentUrl,
        title: page_data === null || page_data === void 0 ? void 0 : page_data.og_title,
        description: page_data === null || page_data === void 0 ? void 0 : page_data.og_description,
        images: [{
          url: 'https://res.cloudinary.com/dgxoa4a9i/image/upload/page/landing-page/1688559694xs86e.webp',
          width: 800,
          height: 600,
          alt: page_data === null || page_data === void 0 ? void 0 : page_data.og_title
        }, {
          url: 'https://res.cloudinary.com/dgxoa4a9i/image/upload/page/landing-page/1688559694xs86e.webp',
          width: 800,
          height: 600,
          alt: page_data === null || page_data === void 0 ? void 0 : page_data.og_title
        }]
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Banner, {
      data: home_banner,
      windowWidth: windowWidth,
      offset: offset,
      feature_data: feature_box
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Services, {
      services_data: services
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Invest, {
      data: investing,
      offsetContainer: offset
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
      ref: ref,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Products, {
        data: products
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(USP, {
        data: expert,
        offset: offset
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: "home_easy_trade",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(EasyTrade, {
          data: easytrade
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: "home_easy_trade",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(EasyTrade, {
          version: true,
          data: easyx
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Investors, {
        id: "investor_calculator",
        data: investor,
        offset: offset
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Newsletter, {
        data: newsletter
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(WhoIs, {
        data: who
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(TestimonialV1, {
        data: testimonial
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(CTAV3, {
        data: cta,
        winWidth: winWidth,
        offset: offset
      })]
    })]
  });
}; // run this line
// http://cms.shantasecurities.com/api/get-req-data/sections?type=slug&value=landing-page&get_section=yes&image=yes&file=yes&gallery=yes&post=yes


var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Home);

/***/ }),

/***/ 45728:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(33539);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 42708:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YD": function() { return /* binding */ useInView; }
/* harmony export */ });
/* unused harmony exports InView, defaultFallbackInView, observe */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
"use client";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/InView.tsx


// src/observe.ts
var observerMap = /* @__PURE__ */ new Map();
var RootIds = /* @__PURE__ */ new WeakMap();
var rootId = 0;
var unsupportedValue = void 0;
function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
function getRootId(root) {
  if (!root)
    return "0";
  if (RootIds.has(root))
    return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
function optionsToId(options) {
  return Object.keys(options).sort().filter(
    (key) => options[key] !== void 0
  ).map((key) => {
    return `${key}_${key === "root" ? getRootId(options.root) : options[key]}`;
  }).toString();
}
function createObserver(options) {
  const id = optionsToId(options);
  let instance = observerMap.get(id);
  if (!instance) {
    const elements = /* @__PURE__ */ new Map();
    let thresholds;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        var _a;
        const inView = entry.isIntersecting && thresholds.some((threshold) => entry.intersectionRatio >= threshold);
        if (options.trackVisibility && typeof entry.isVisible === "undefined") {
          entry.isVisible = inView;
        }
        (_a = elements.get(entry.target)) == null ? void 0 : _a.forEach((callback) => {
          callback(inView, entry);
        });
      });
    }, options);
    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }
  return instance;
}
function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {
    };
  }
  const { id, observer, elements } = createObserver(options);
  const callbacks = elements.get(element) || [];
  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }
  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    callbacks.splice(callbacks.indexOf(callback), 1);
    if (callbacks.length === 0) {
      elements.delete(element);
      observer.unobserve(element);
    }
    if (elements.size === 0) {
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}

// src/InView.tsx
function isPlainChildren(props) {
  return typeof props.children !== "function";
}
var InView = class extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(props) {
    super(props);
    __publicField(this, "node", null);
    __publicField(this, "_unobserveCb", null);
    __publicField(this, "handleNode", (node) => {
      if (this.node) {
        this.unobserve();
        if (!node && !this.props.triggerOnce && !this.props.skip) {
          this.setState({ inView: !!this.props.initialInView, entry: void 0 });
        }
      }
      this.node = node ? node : null;
      this.observeNode();
    });
    __publicField(this, "handleChange", (inView, entry) => {
      if (inView && this.props.triggerOnce) {
        this.unobserve();
      }
      if (!isPlainChildren(this.props)) {
        this.setState({ inView, entry });
      }
      if (this.props.onChange) {
        this.props.onChange(inView, entry);
      }
    });
    this.state = {
      inView: !!props.initialInView,
      entry: void 0
    };
  }
  componentDidMount() {
    this.unobserve();
    this.observeNode();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  }
  componentWillUnmount() {
    this.unobserve();
  }
  observeNode() {
    if (!this.node || this.props.skip)
      return;
    const {
      threshold,
      root,
      rootMargin,
      trackVisibility,
      delay,
      fallbackInView
    } = this.props;
    this._unobserveCb = observe(
      this.node,
      this.handleChange,
      {
        threshold,
        root,
        rootMargin,
        // @ts-ignore
        trackVisibility,
        // @ts-ignore
        delay
      },
      fallbackInView
    );
  }
  unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();
      this._unobserveCb = null;
    }
  }
  render() {
    const { children } = this.props;
    if (typeof children === "function") {
      const { inView, entry } = this.state;
      return children({ inView, entry, ref: this.handleNode });
    }
    const {
      as,
      triggerOnce,
      threshold,
      root,
      rootMargin,
      onChange,
      skip,
      trackVisibility,
      delay,
      initialInView,
      fallbackInView,
      ...props
    } = this.props;
    return React.createElement(
      as || "div",
      { ref: this.handleNode, ...props },
      children
    );
  }
};

// src/useInView.tsx

function useInView({
  threshold,
  delay,
  trackVisibility,
  rootMargin,
  root,
  triggerOnce,
  skip,
  initialInView,
  fallbackInView,
  onChange
} = {}) {
  var _a;
  const [ref, setRef] = react__WEBPACK_IMPORTED_MODULE_0__.useState(null);
  const callback = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  const [state, setState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    inView: !!initialInView,
    entry: void 0
  });
  callback.current = onChange;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(
    () => {
      if (skip || !ref)
        return;
      let unobserve;
      unobserve = observe(
        ref,
        (inView, entry) => {
          setState({
            inView,
            entry
          });
          if (callback.current)
            callback.current(inView, entry);
          if (entry.isIntersecting && triggerOnce && unobserve) {
            unobserve();
            unobserve = void 0;
          }
        },
        {
          root,
          rootMargin,
          threshold,
          // @ts-ignore
          trackVisibility,
          // @ts-ignore
          delay
        },
        fallbackInView
      );
      return () => {
        if (unobserve) {
          unobserve();
        }
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      Array.isArray(threshold) ? threshold.toString() : threshold,
      ref,
      root,
      rootMargin,
      triggerOnce,
      skip,
      trackVisibility,
      fallbackInView,
      delay
    ]
  );
  const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
  const previousEntryTarget = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
    previousEntryTarget.current = entryTarget;
    setState({
      inView: !!initialInView,
      entry: void 0
    });
  }
  const result = [setRef, state.inView, state.entry];
  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}

//# sourceMappingURL=index.mjs.map

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(45728); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);